<div class="imageDev mt-2 pt-3">
    <div class="card">
        <div class="card-header" [class]="master?dados_chamado.prioridade:''" style="padding: 8px 16px;" [style.heigth]="master?'55px':'45px'">
            <div class="col-12 d-flex row">
                <span style="display: flex; flex-direction: row; width: 90%;">
                    <strong>Protocolo:&nbsp;&nbsp;</strong>{{uuid_chamado}}&nbsp;&nbsp;|&nbsp;&nbsp;
                    <span style="display: flex; flex-direction: row;">
                        <strong>Status:&nbsp;&nbsp;</strong>
                        <span *ngIf="!master" class="d-flex">{{dados_chamado.status}}</span>
                        <span *ngIf="master" class="d-flex">
                            <select id="select-status" class="form-select select-header select-status" (change)="alterarStatusChamado()">
                                <option *ngFor="let item of listaStatus" [value]="item.value">{{item.label}}</option>
                            </select>
                        </span>
                    </span>
                    &nbsp;&nbsp;|&nbsp;&nbsp;<strong>Categoria:&nbsp;&nbsp;</strong><span *ngIf="!master">{{dados_chamado.categoria}}</span>
                    <span *ngIf="master">
                        <select id="select-categoria" class="form-select select-header select-prioridade" (change)="alterarCategoriaChamado()">
                            <option *ngFor="let item of listaCategorias" [value]="item.value">{{item.label}}</option>
                        </select>
                    </span>
                    <span *ngIf="master"><span style="display: flex; flex-direction: row;">&nbsp;&nbsp;|&nbsp;&nbsp;Prioridade:&nbsp;&nbsp;
                            <select id="select-prioridade" class="form-select select-header select-prioridade" (change)="alterarPrioridadeChamado()">
                                <option *ngFor="let item of listaPrioridades" [value]="item.value">{{item.label}}</option>
                            </select>
                        </span>
                    </span>&nbsp;&nbsp;|
                    <div class="form-check form-switch" style="margin-left: 5px;">
                        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
                            (change)="alterarNotificacao()">
                        <label class="form-check-label" for="flexSwitchCheckDefault"><span *ngIf="!showTimeOut">Notificações</span></label>
                    </div>
                    <span *ngIf="showTimeOut">Aguarde antes de fazer a
                        operação</span>

                </span>
                <span style="width: 19%; display: flex; justify-content: end;">
                    <a class="btn btn-success btn-sm" id="tooltip" routerLink="/chamados"
                        style="height: 30px; position: absolute; right: 8px; top: 8px;"
                        title="Listagem de chamados"><i class="fa fa-arrow-left"></i> Todos Chamados</a>
                </span>
            </div>
        </div>
        <div class="card-body" style="position: relative;">
            <div class="col-12 d-flex row">
                <div class="col-4 d-flex" style="flex-direction: column; max-height: 480px;">
                    <div class="card col-12 d-flex">
                        <div class="card-header" [class]="master?dados_chamado.prioridade:''">
                            Informações
                            <button class="btn btn-add-desc" title="Clique aqui para adicionar uma descrição ao chamado"
                                *ngIf="!dados_chamado.descricao && !descricaoInput && dados_chamado.uuid_usuario_abertura == uuid_user"
                                (click)="habilitarAdicaoDescricao()">Adicionar Descrição</button>

                            <div class="fload-right">
                                <button class="btn btn-cancel-desc" title="Clique aqui para adicionar uma descrição ao chamado"
                                    *ngIf="!dados_chamado.descricao && descricaoInput"
                                    (click)="habilitarAdicaoDescricao()">Cancelar</button>

                                <button class="btn btn-save-desc" title="Clique aqui para adicionar uma descrição ao chamado"
                                    *ngIf="!dados_chamado.descricao && descricaoInput"
                                    (click)="adicionarDescricaoChamado()">Salvar</button>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="col-12 d-flex row">
                                <div class="col-12 d-flex"><strong>Assunto:&nbsp;&nbsp;</strong><span>{{dados_chamado.assunto}}</span></div>
                                <div class="col-12 d-flex"><strong>Gestor:&nbsp;&nbsp;</strong><span>{{dados_chamado.nome_gestor}}</span></div>
                                <div class="col-12 d-flex help"
                                    [title]="dados_chamado.nome_empresa + (dados_chamado.razao_social?(' ou ' + dados_chamado.razao_social):'')"><strong>Empresa:&nbsp;&nbsp;</strong><span>{{retornaNomeEmpresaReduzido(dados_chamado.nome_empresa)}}</span></div>
                                <div class="col-12 d-flex help" *ngIf="master" title="Tipo da empresa abertura"><strong>Tipo de Empresa:&nbsp;&nbsp;</strong><span>{{retornaNomeEmpresaReduzido(dados_chamado.tipo_empresa)}}</span></div>
                                <div class="col-12 d-flex" *ngIf="master"><strong>Prioridade:&nbsp;&nbsp;</strong><span>{{dados_chamado.prioridade}}</span></div>
                                <div class="col-12 d-flex help" title="Data e Hora de Abertura do Chamado"><strong>Abertura:&nbsp;&nbsp;</strong><span>{{retornaDataHora(dados_chamado.data_hora_abertura)}}</span></div>
                                <div class="col-12 d-flex help" *ngIf="dados_chamado.protocolo_orcamento"><strong>Protocolo Orçamento:&nbsp;&nbsp;</strong><span>{{dados_chamado.protocolo_orcamento}}</span></div>
                                <div class="col-12 d-flex help" *ngIf="veiculo"><strong>Veículo:&nbsp;&nbsp;</strong><span>{{veiculo}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="card col-12 d-flex mt-3 div-anexos">
                        <div class="card-header" [class]="master?dados_chamado.prioridade:''">
                            Anexos <span style="float: right;">{{anexoStatus}}</span>
                        </div>
                        <div class="card-body">
                            <div class="col-12 d-flex row">
                                <div class="col-12 d-flex">
                                    <input type="file" id="input-arquivos" #arquivos class="form-control mr-1" (change)="salvarArquivos(arquivos)"
                                        multiple>
                                </div>
                                <div class="card-anexos">
                                    <div class="col-12 d-flex anexo" *ngFor="let anexo of listaAnexosExibicao">
                                        <span class="col-10">{{anexo.nome}}</span>
                                        <div class="btns-action">
                                            <button class="btn btn-open" title="Abrir Arquivo" (click)="abrirArquivo(anexo.uuid)">
                                                <i class="fa fa-folder-open"></i>
                                            </button>
                                            <button class="btn btn-mencao" title="Mencionar Arquivo" (click)="marcarArquivo(anexo.uuid, anexo.nome)">
                                                <i class="fa fa-reply"></i>
                                            </button>
                                            <button class="btn btn-remove" title="Remover Anexo" (click)="removerAnexo(anexo.uuid)"
                                                *ngIf="anexo.canDelete">
                                                <i class="fa fa-times"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 d-flex justify-content-center mt-3" *ngIf="listaAnexosExibicao.length == 0">
                                    <span><strong>Sem Anexos</strong></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-8 d-flex" style="flex-direction: column;">
                    <div class="card col-12 d-flex" *ngIf="dados_chamado.descricao || descricaoInput">
                        <div class="card-header" [class]="master?dados_chamado.prioridade:''">
                            Descrição
                        </div>
                        <div class="card-body">
                            <div class="col-12 d-flex" *ngIf="!descricaoInput"><span class="span-desc">{{dados_chamado.descricao?dados_chamado.descricao:'Não informado'}}</span></div>
                            <div class="col-12 d-flex" *ngIf="descricaoInput">
                                <textarea class="descricao-textarea" id="textAreaDescricao" placeholder="Digite aqui a descrição" cols="30"
                                    rows="10"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="card col-12 d-flex div-chat" [class]="dados_chamado.descricao || descricaoInput?'mt-3':''">
                        <div class="card-header" [class]="master?dados_chamado.prioridade:''">
                            Chat <span class="floar-right">{{SocketStatus}} <div class="status-indicador"
                                    [class]="SocketStatus == 'Conectado'?'connected':'disconnected'"></div></span>
                        </div>
                        <div class="card-body">
                            <div class="col-12 d-flex justify-content-center" *ngIf="!(listaMsg.length > 0)" (click)="clickTextoAlerta()"
                                style="align-items: center; height: 70%; flex-direction: column;">
                                <span class="justify"><strong>Ainda não há mensagens neste chamado <br>
                                        Envie uma mensagem para iniciar a conversa</strong>
                                </span>
                                <div class="col-12 d-flex mencao" *ngIf="itenMencionado?.nome">
                                    {{itenMencionado.nome}}
                                    <button class="btn-close-mencao" (click)="removerMencao()">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                            <div #content *ngIf="listaMsg.length > 0" class="feedChat card-chat" id="chatBox">
                                <div class="div-btn-load-more" *ngIf="!todasCarregadas && primeiraMensagemNessaSessao()">
                                    <button class="btn btn-load-more" *ngIf="!carregandoMais" (click)="carregarMaisMensagens()">Carregar Mais</button>
                                    <div class="spinner-border" role="status" *ngIf="carregandoMais">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                                <div class="div-btn-load-more" *ngIf="todasCarregadas">
                                    <span>Todas as Mensagens foram carregadas!</span>
                                </div>
                                <div #messages *ngFor="let msg of listaMsg; let i = index" class="msgDiv" [class]="msg.side">
                                    <div class="col-12 d-flex msg-{{msg.side}}" style="margin-top: 3px;">
                                        <div class="triangulo" *ngIf="msg.side == 'left'">
                                            <div class="triangulo-para-{{msg.side}}"></div>
                                        </div>
                                        <div class="msg">
                                            <span><strong *ngIf="msg.side != 'rigth'" [style.color]="retornaCorDoUsuario(msg.sender_name)">{{msg.sender_name}}<br></strong>{{msg.content}}</span>
                                            <div class="col-12 d-flex" *ngIf="msg.mencao && listaAnexosExibicao.length > 0">
                                                <button class="btn btn-open-anexo"
                                                    title="Clique aqui para abrir o anexo" (click)="abrirArquivo(msg.mencao)">{{retornaNomeArquivoMensao(msg.mencao)}}</button>
                                            </div>
                                        </div>
                                        <div class="triangulo" *ngIf="msg.side != 'left'">
                                            <div class="triangulo-para-{{msg.side}}"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 d-flex mencao" *ngIf="itenMencionado?.nome">
                                    {{itenMencionado.nome}}
                                    <button class="btn-close-mencao" (click)="removerMencao()">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="text-btn-div">
                                <div class="col-12 d-flex">
                                    <textarea id="msgSend" [rows]="rows" name="msg" placeholder="Digite Aqui"
                                        [disabled]="dados_chamado.status == 'Finalizado'"
                                        [title]="dados_chamado.status == 'Finalizado'?'O chamado foi Finalizado':'Digite aqui sua mensagem'"></textarea>
                                    <div class="d-btn">
                                        <button class="btn-send" (click)="enviarMensagem()" [disabled]="!habilitaBotaoEnviar()"
                                            [title]="titleBotaoEnviar()">
                                            <i class="fa fa-send"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>